import React, { FC, ReactNode } from 'react';

import './HorizontalScroll.scss';

export const HorizontalScroll: FC<{ children?: ReactNode | ReactNode[] }> = ({ children }) => {
  return <div className="HorizontalScroll">{children}</div>;
};
